import { Container, Grid } from '@mui/material';
import usePagination from 'src/hooks/usePagination';
import CustomTable from 'src/components/table/table';
import TabTitle from 'src/components/tabTitle/tabTitle';
import { GET_BOOKING, UPDATE_BOOKING } from 'src/apiService/apiDeclaration';
import PageHeader from 'src/components/pageHeader/PageHeader';
import { bookingTableColumns } from 'src/constants/columnConfig';
import { BOOKING_STATUS } from 'src/config/enum';
import MenuPopover from 'src/components/menu/menu';
import { useModal } from 'src/hooks/useModal';
import { showErrorTost, showSuccessTost } from 'src/constants';

const RejectedPage = () => {
  const { setDialogData, handleModalClose } = useModal();
  const { paginationModel, setPaginationModel, loading, data, refresh } = usePagination(GET_BOOKING, {
    status: BOOKING_STATUS.REJECTED,
  });
  const updatedBookingTable = [...bookingTableColumns];
  updatedBookingTable.push({
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: ({ row }) => {
      return (
        <MenuPopover
          menuArray={[
            {
              iconPath: require(`src/assets/trash.png`),
              name: 'Move to Trash',
              action: () => {
                setDialogData({
                  showModal: true,
                  description: 'Are you sure you want to move this booking to trash?',
                  onConfirm: () => onDelete(row._id),
                });
              },
            },
          ]}
        />
      );
    },
  });
  const onDelete = async (id) => {
    try {
      await UPDATE_BOOKING(id, { deleted: true });
      onSuccess();
      showSuccessTost('Booking deleted successfully');
    } catch (error) {
      console.log(error);
      showErrorTost('Error inn deleting booking');
    }
  };
  const onSuccess = () => {
    handleModalClose();
    refresh();
  };

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <TabTitle title={'Rejected'} />
        <Grid item xs={12}>
          <PageHeader pageTitle={'Rejected'} />
        </Grid>

        <Grid item xs={12}>
          <CustomTable
            loading={loading}
            isServerSidePagination
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            columns={updatedBookingTable}
            rows={data.rows}
            rowCount={data.rowCount}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default RejectedPage;
